var map = {
	"./music-instructions.json": 4700,
	"./music-library-intro2024.json": 4701,
	"./music-library-launch2024.json": 4702,
	"./music-progression.json": 4703,
	"./startSourcesAdvanced.json": 4704,
	"./startSourcesSimple.json": 4705,
	"./startSourcesSimple2.json": 4706,
	"./startSourcesTracks.json": 4707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4468;